import{m as o}from"./chunk-HBP5N4FR.js";o();var i=()=>{var n;let c=typeof window!="undefined"?(n=window==null?void 0:window.location)==null?void 0:n.search:"",t=new URLSearchParams(c),e=Object.fromEntries(t);return e==null?void 0:e.accessToken};export{i as a};
//# sourceMappingURL=chunk-XBAP2D3B.js.map
